import { GallerySlider } from '@/core/blocks';
import { Icon } from '@/core/icon';
import { Dialog, DialogClose, DialogContent, DialogTitle, DialogTrigger, Typography } from '@/core/ui';
import type { ICupHighlight, ICupsGallery } from '@/types';
import { useTranslation } from 'react-i18next';

type Props = { highlight: ICupHighlight['highlight']; gallery: ICupsGallery['gallery'] };

export const Slide3 = ({ highlight, gallery }: Props) => {
  const { t } = useTranslation('translation');

  return (
    <>
      <div className='bg-content1 h-screen relative'>
        <div className='flex flex-col items-center justify-between h-full'>
          <div className='flex space-x-6 w-full justify-end'>
            <div className='flex flex-col justify-between pl-10'>
              <Typography className='text-chalk text-[30px] leading-[28.5px] tracking-[1.5px] mt-16'>
                {t('cups.gallery.text')}
              </Typography>
              <div className='items-end flex max-w-[219px]'>
                <Typography className='text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]'>
                  {highlight.media_1.caption}
                </Typography>
              </div>
            </div>
            <div className=''>
              <img
                alt={highlight.media_1.caption || ''}
                src={highlight.media_1.path || ''}
                className='w-[1479px] h-[480px] object-cover'
              />
            </div>
          </div>
          <div className='relative'>
            <img
              alt={highlight.media_2.caption || ''}
              src={highlight.media_2.path || ''}
              className='mr-16 w-[1444px] h-[504px] object-cover'
            />
            {!!gallery.length && (
              <Dialog>
                <DialogTrigger asChild>
                  <div className='absolute bottom-[120px] -right-24'>
                    <button
                      type='button'
                      className='text-chalk flex items-center justify-center space-x-[10px] bg-danger rounded-full py-[25px] px-[50px]'
                    >
                      <Typography className='py-1 text-chalk text-3xl leading-[28.5px] uppercase'>
                        {t('home.see')}
                      </Typography>
                      <Icon name='PLUS' />
                    </button>
                  </div>
                </DialogTrigger>
                <DialogContent
                  closeJsx={
                    <DialogClose className='absolute right-8 top-8 rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground'>
                      <Icon name={'X_ICON'} className='bg-danger rounded-full p-2 w-16 h-16' color='white' />
                      <span className='sr-only'>Close</span>
                    </DialogClose>
                  }
                  className='bg-transparent flex justify-center items-center shadow-none'
                >
                  <DialogTitle />
                  <GallerySlider slides={gallery} />
                </DialogContent>
              </Dialog>
            )}
            {/* <div className='absolute bottom-32 -right-20'>
              <button
                type='button'
                className='text-chalk flex items-center justify-center space-x-[10px] bg-danger rounded-full h-[96px] w-[174px]'
              >
                <Typography className='pt-1 text-chalk text-3xl leading-[28.5px] tracking-normal uppercase'>
                  ver
                </Typography>
                <Icon name='PLUS' />
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
